module.exports = __webpack_public_path__ + "static/media/127.7a0b854e.png";